// extracted by mini-css-extract-plugin
export default {"MainContainer":"Common_MainContainer__L-5Kt","headerDiv":"Common_headerDiv__b5x3M"};